import { MutableRefObject, useRef, useState } from "react";

function useAsyncReference<T>(value: T, isProp = false): [ MutableRefObject<T>, (newState: T) => void ] {
    const ref = useRef<T>(value);
    const [, forceRender] = useState(false);

    function updateState(newState: T) {
        if (!Object.is(ref.current, newState)) {
            ref.current = newState;
            forceRender(s => !s);
        }
    }

    if (isProp) {
        throw new Error("useAsyncReference- no support for isProp anymore");
    }

    return [ ref, updateState ];
}

export default useAsyncReference;
